import { utilService } from "./utilService";
import { StorageService } from "./storage.service";
import {  CONSTANTS } from "../constants";

const authenticated = () => {
  return (
    "true" === StorageService.getStorageItem(localStorage, "isLoggedIn") &&
    (StorageService.getStorageItem(sessionStorage, "token") !== null ||
      StorageService.getStorageItem(localStorage, "token") !== null)
  );
};

const isAuthenticated = () => {
  return new Promise((resolve, reject) => {
    if (authenticated()) {
      resolve(true);
    } else {
      resolve(false);
    }
  });
};

const logout = async (params?: any) => {
  // Remove all keys except 'applanguage' from localStorage and sessionStorage
  const preserveKey = 'appLanguage';
  // Remove from localStorage
  Object.keys(localStorage).forEach((key) => {
    if (key !== preserveKey) {
      localStorage.removeItem(key);
    }
  });
  // Remove from sessionStorage
  Object.keys(sessionStorage).forEach((key) => {
    if (key !== preserveKey) {
      sessionStorage.removeItem(key);
    }
  });
  window.location.href = '/login';

};

const clearStorage = () => {
  const preserveKey = 'appLanguage';
  Object.keys(localStorage).forEach((key) => {
    if (key !== preserveKey) {
      localStorage.removeItem(key);
    }
  });
  Object.keys(sessionStorage).forEach((key) => {
    if (key !== preserveKey) {
      sessionStorage.removeItem(key);
    }
  });
}

export const AuthService = {
  logout,
  clearStorage,
  isAuthenticated,
};
